enum Look {
  Makeup = 'Makeup',
  // Add avatar look type here in future
}

export default Look;
